import React from "react";
import "./Footer.css";
import {
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaEnvelope,
  FaTwitter,
  FaFacebookF,
  FaInstagram,
  FaTumblr,
  FaLinkedinIn,
  FaPinterestP,
  FaVimeoV,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Company Info */}
        <div className="footer-col">
          <h2 className="footer-logo">
            <span className="highlight">Trip</span>Wise Travel
          </h2>
          <p>
            Discover the world with TripWise. Adventure, relaxation, and
            unforgettable experiences await you.
          </p>
          <ul className="footer-contact">
            <li>
              <FaPhoneAlt /> 8574968512
            </li>
            <li>
              <FaMapMarkerAlt /> Eighth Avenue 487, 
            </li>
            <li>
              <FaEnvelope /> support@tripwise.com
            </li>
          </ul>
        </div>

        {/* Latest Posts */}
        <div className="footer-col">
          <h3>Latest Posts</h3>
          <ul className="footer-posts">
            <li>
              Traveling – It Leaves You Speechless, Then Turns You Into A
              Storyteller
              <span> February 21, 2024</span>
            </li>
            <li>
              A Journey Is Always Best Measured In New Friends, Rather Than
              Miles
              <span> February 18, 2024</span>
            </li>
          </ul>
        </div>

        {/* Twitter Feed */}
        <div className="footer-col">
          <h3>Twitter Feed</h3>
          <p>
            For all the latest news and updates, follow us on Twitter:{" "}
            <a href="https://twitter.com/tripwise">@TripWise</a>
          </p>
        </div>

        {/* Instagram Feed */}
        <div className="footer-col">
          <h3>Instagram Feed</h3>
          <div className="footer-socials">
            <FaTwitter />
            <FaFacebookF />
            <FaInstagram />
            <FaTumblr />
            <FaLinkedinIn />
            <FaPinterestP />
            <FaVimeoV />
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <p>© 2024 TripWise Travel, All Rights Reserved</p>
      </div>
    </footer>
  );
};

export default Footer;
